/*
 * UpperEast — quick-add dalle card prodotto (snippets/uppereast-prod-card.liquid).
 *
 * Caricato come <script type="module">: anche se lo stesso tag compare in più griglie della pagina
 * il browser lo esegue UNA volta sola. Delega l'evento submit sul document, quindi funziona anche
 * sulle card inserite dopo (filtri collezione, raccomandazioni).
 *
 * Flusso preferito: window.ueCart.add() del filone carrello (snippets/ue-cart-runtime.liquid) →
 * aggiunge via /cart/add.js, traccia "Added to Cart" su Klaviyo, ridisegna e apre il drawer.
 * Se il runtime non c'è: POST /cart/add.js con le sezioni del cart drawer di Dawn e
 * drawer.renderContents(risposta) (stesso contratto di product-form.js).
 * Ultimo fallback: submit nativo del form → /cart/add → /cart.
 */
const FORM_SELECTOR = 'form[data-ue-qa]';
const ADDED_MS = 1800;

// Testi visibili: window.ueT da snippets/ue-i18n-js.liquid (tradotti con | t); il ripiego italiano resta se lo snippet manca.

function cartRoot() {
  const add = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return `${add}.js`;
}

function cartUrl() {
  return (window.routes && window.routes.cart_url) || '/cart';
}

function getDrawer() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return null;
  if (typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') return null;
  return drawer;
}

function setStatus(form, text, isError) {
  const status = form.querySelector('[data-ue-qa-status]');
  if (!status) return;
  status.textContent = text || '';
  status.style.color = isError ? '' : '#15803D';
}

function setButton(form, state) {
  const btn = form.querySelector('[data-ue-qa-btn]');
  const label = form.querySelector('[data-ue-qa-label]');
  if (!btn) return;
  if (!btn.dataset.ueLabel && label) btn.dataset.ueLabel = label.textContent;
  btn.classList.remove('is-loading', 'is-added');
  btn.removeAttribute('aria-disabled');
  if (state === 'loading') {
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    if (label) label.textContent = (window.ueT && window.ueT.adding) || 'Aggiungo…';
  } else if (state === 'added') {
    btn.classList.add('is-added');
    if (label) label.textContent = (window.ueT && window.ueT.added_check) || 'Aggiunto ✓';
    window.setTimeout(() => setButton(form, 'idle'), ADDED_MS);
  } else if (label && btn.dataset.ueLabel) {
    label.textContent = btn.dataset.ueLabel;
  }
}

async function handleSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;

  const btn = form.querySelector('[data-ue-qa-btn]');
  if (btn && btn.getAttribute('aria-disabled') === 'true') {
    event.preventDefault();
    return;
  }

  const variantId = Number(new FormData(form).get('id'));

  // 1) Runtime carrello del tema (filone carrello): tracking + drawer + pagina /cart gestiti lì.
  if (window.ueCart && typeof window.ueCart.add === 'function' && variantId) {
    event.preventDefault();
    setStatus(form, '');
    setButton(form, 'loading');
    try {
      await window.ueCart.add([{ id: variantId, quantity: 1 }], { open: true });
      setButton(form, 'added');
      setStatus(form, (window.ueT && window.ueT.added_to_cart) || 'Aggiunto al carrello');
      window.setTimeout(() => setStatus(form, ''), ADDED_MS + 400);
    } catch (error) {
      setButton(form, 'idle');
      setStatus(form, (error && error.message) || (window.ueT && window.ueT.unavailable_now) || 'Non disponibile al momento.', true);
    }
    return;
  }

  // 2) Dawn standard. Senza cart drawer (tema su "pagina carrello") lasciamo il submit nativo → /cart.
  const drawer = getDrawer();
  if (!drawer) return;

  event.preventDefault();
  setStatus(form, '');
  setButton(form, 'loading');

  const body = new FormData(form);
  body.append('sections', drawer.getSectionsToRender().map((s) => s.id).join(','));
  body.append('sections_url', window.location.pathname);
  if (typeof drawer.setActiveElement === 'function' && btn) drawer.setActiveElement(btn);

  let response;
  try {
    const res = await fetch(cartRoot(), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body,
    });
    response = await res.json();
    if (!res.ok || response.status) {
      setButton(form, 'idle');
      setStatus(form, response.description || response.message || (window.ueT && window.ueT.unavailable_now) || 'Non disponibile al momento.', true);
      return;
    }
  } catch (error) {
    // Rete o JSON non validi: proviamo il percorso classico (POST /cart/add → /cart).
    setButton(form, 'idle');
    form.submit();
    return;
  }

  try {
    // publish / PUB_SUB_EVENTS sono globali di Dawn (pubsub.js, constants.js): stesso evento di product-form.js
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'ue-card-quick-add',
        productVariantId: body.get('id'),
        cartData: response,
      });
    }
    drawer.renderContents(response);
    drawer.classList.remove('is-empty');
    setButton(form, 'added');
    setStatus(form, (window.ueT && window.ueT.added_to_cart) || 'Aggiunto al carrello');
    window.setTimeout(() => setStatus(form, ''), ADDED_MS + 400);
  } catch (error) {
    // Il prodotto è già nel carrello: se il drawer non si ridisegna, portiamo la cliente al carrello.
    window.location.href = cartUrl();
  }
}

document.addEventListener('submit', handleSubmit);
